/**
 * 블소 - 문파
 */
import { Fragment } from 'react';
import { SERVER_TYPE, SERVICE_ALIAS } from '@constants/index';
import { setYMDDateFormat, strReplaceUrl } from '@utils/index';
import type { IGuild, ISetGuild, l10nType } from '@type/index';

export const setGuildItem = (item: IGuild, serverType?: string): ISetGuild | null => {
  return item && typeof item === 'object'
    ? {
        ...item,
        url: `/world/guild/${serverType ?? SERVER_TYPE?.[SERVICE_ALIAS.BNS]?.LIVE}/${item?.serverId}/${strReplaceUrl(item?.guildName)}`,
      }
    : null;
};

const GuildArticle = ({ item, l10n, serverType }: { item: IGuild; l10n: l10nType, serverType?: string; }) => {
  const data = setGuildItem(item, serverType);

  if (!data) {
    return <Fragment />;
  }

  const { url, guildName, serverName, leaderCharacterName, level, createdDatetime } = data;
  return (
    <div className="searc-item-content">
      <div className="search-item-title">
        <a href={url} dangerouslySetInnerHTML={{ __html: guildName }}></a>
      </div>
      <div className="search-item-info">{serverName}</div>
      <div className="search-item-info">
        <span>문파장</span>
        <span>{leaderCharacterName}</span>
        <span>Lv {level}</span>
        <span>창설일 {setYMDDateFormat(createdDatetime)}</span>
      </div>
    </div>
  );
};

export default GuildArticle;
